// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Security_securityCard__WRgfh {
  margin-bottom: 20px;
}
.Security_securityCard__WRgfh .ant-card-head-title {
  font-weight: bold;
}

.Security_cardTitle__xACfq {
  display: flex;
  align-items: center;
}

.Security_titleIcon__xmhFl {
  margin-right: 8px;
  font-size: 18px;
}

.Security_securityAlert__fuQ7p {
  margin: 16px 0;
}

.Security_zonesContainer__TNbxZ {
  margin-top: 16px;
}

.Security_zoneItem__WzkVq {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 4px;
}
.Security_zoneItem__WzkVq:last-child {
  margin-bottom: 0;
}

.Security_selinuxEnabled__Ul9l2 {
  color: #52c41a;
}

.Security_selinuxDisabled__SwbU9 {
  color: #ff4d4f;
}

.Security_selinuxPermissive__rfmYV {
  color: #faad14;
}`, "",{"version":3,"sources":["webpack://./src/pages/Detail/component/security/Security.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAEI;EACE,iBAAA;AAAN;;AAKA;EACE,aAAA;EACA,mBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAFF;AAIE;EACE,gBAAA;AAFJ;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,cAAA;AAHF","sourcesContent":[".securityCard {\n  margin-bottom: 20px;\n  \n  :global {\n    .ant-card-head-title {\n      font-weight: bold;\n    }\n  }\n}\n\n.cardTitle {\n  display: flex;\n  align-items: center;\n}\n\n.titleIcon {\n  margin-right: 8px;\n  font-size: 18px;\n}\n\n.securityAlert {\n  margin: 16px 0;\n}\n\n.zonesContainer {\n  margin-top: 16px;\n}\n\n.zoneItem {\n  margin-bottom: 24px;\n  padding: 16px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n  \n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.selinuxEnabled {\n  color: #52c41a;\n}\n\n.selinuxDisabled {\n  color: #ff4d4f;\n}\n\n.selinuxPermissive {\n  color: #faad14;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"securityCard": `Security_securityCard__WRgfh`,
	"cardTitle": `Security_cardTitle__xACfq`,
	"titleIcon": `Security_titleIcon__xmhFl`,
	"securityAlert": `Security_securityAlert__fuQ7p`,
	"zonesContainer": `Security_zonesContainer__TNbxZ`,
	"zoneItem": `Security_zoneItem__WzkVq`,
	"selinuxEnabled": `Security_selinuxEnabled__Ul9l2`,
	"selinuxDisabled": `Security_selinuxDisabled__SwbU9`,
	"selinuxPermissive": `Security_selinuxPermissive__rfmYV`
};
export default ___CSS_LOADER_EXPORT___;
